import axios from "axios";
import Cookies from "js-cookie";
import { toastError } from "./utils/Toast";
import { te } from "./utils/errorsTranslation";

const http = axios.create();

export const setupInterceptors = (history, logoutUser) => {
  http.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          //Remove the JWT access token
          Cookies.remove("access-token");
          //Clear the local storage
          localStorage.removeItem("user");
          localStorage.removeItem("loginMethod");
          //Logout user
          logoutUser();
          // Unauthorized
          history.push("/error");
        } else if (error.response.status >= 500) {
          toastError(te("internal_server_error"));
        }
      }

      return error.response;
    }
  );
};

export default http;
